import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { BounceLoader } from "react-spinners";
import parse from "html-react-parser";
import { apiUrl } from "../../common/config/apiUrl";
import { toast } from "react-hot-toast";
import PostComment from "./postComment";
import { FaCircleRight } from "react-icons/fa6";
import moment from "moment";
import Seo from "../../common/component/Seo";

const SinglePost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [latestPosts, setLatestPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  // Meta states
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const postResponse = await axios.get(
          `${apiUrl}post/singlepost/${slug}`
        );
        setPost(postResponse?.data?.data?.single_post);
        setTags(postResponse?.data?.data?.single_post?.tags[0] || []);
      } catch (error) {
        console.error("Error fetching blog post:", error);
        toast.error("Failed to load blog post. Please try again.");
      }

      try {
        const latestResponse = await axios.get(
          `${apiUrl}post/latest?latest=10`
        );
        setLatestPosts(latestResponse?.data?.data?.latest_post);
      } catch (error) {
        console.error("Error fetching latest posts:", error);
        toast.error("Failed to load latest posts.");
      }

      setLoading(false);
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <BounceLoader color="#FFC400" size={60} />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="text-center py-10 text-red-500 text-lg font-semibold">
        Post not found!
      </div>
    );
  }
  return (
    <>
      <Seo
        metaTitle={tags.meta_title}
        metaDescription={tags.meta_description}
        metaKeywords={tags.meta_key}
      />
      <div className="max-w-[1280px] mx-auto px-4 py-10 small:flex gap-4">
        {/* Blog Content */}
        <div className=" bg-white  flex-[2.5] rounded-lg  shadow-md border small:p-6 p-4">
          <h1 className="text-xl small:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            {post.title}
          </h1>
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-[250px] md:h-[400px] object-cover rounded-xl mb-6"
          />
          <div className="text-gray-500 mb-6 italic text-sm md:text-base">
            {post.date}
          </div>
          <div className="text-gray-800 leading-relaxed text-sm md:text-lg jost ">
            {parse(post?.body || "")}
          </div>
          <div className="mt-8">
            <h2 className="text-2xl font-bold text-gray-900 ">Comments</h2>

            {post.comments?.length > 0 ? (
              post.comments.map((comment, index) => (
                <div
                  key={index}
                  className="border border-gray-200 rounded-lg p-4 mb-4 bg-gray-50 shadow-sm"
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-gray-900 font-semibold text-sm md:text-base">
                      {comment.name}
                    </span>
                    <span className="text-gray-500 text-xs md:text-sm">
                      {moment(comment.created_at).format("MMMM D, YYYY")}
                    </span>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base bg-white p-3 rounded-lg shadow">
                    {comment.comments}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500 italic p-2">No comments yet.</p>
            )}
          </div>

          <PostComment slug={slug} />
        </div>
        {/* latest Posts  */}
        <div className="bg-white border flex-[1]  max-h-fit rounded-lg  shadow-md small:mt-0 mt-5 ">
          <p className="bg-[#FEC952] h-[7px] w-[53px] ml-4 "></p>
          <div className="small:p-6 p-4">
            <div className=" pl-2 mb-4">
              <h2 className="text-xl text-secondary font-medium">
                Most Popular Post
              </h2>
            </div>
            {latestPosts?.map((latest) => (
              <div
                key={latest?.id}
                className="flex items-center gap-4 mb-4 border-b border-[#FEC952] pb-4 last:border-b-0"
              >
                <img
                  src={latest?.image}
                  alt={latest?.title}
                  className="w-20 h-16 flex-[0.8] object-cover rounded-md"
                />
                <div className="flex-[2]">
                  <h3 className="text-sm font-medium text-gray-800">
                    {latest.title}
                  </h3>

                  <p className="text-gray-500 text-sm mt-1">{latest.date}</p>
                  <Link
                    to={`/blogs/${latest.slug}`}
                    className="text-secondary flex items-center text-md font-medium hover:underline"
                  >
                    Read More{" "}
                    <span className="text-xs">
                      <FaCircleRight className="size-5 text-webOranage mx-2" />
                    </span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SinglePost;
